import React from 'react';
import Button from './Button';
import { actionBg, actionText } from './colors';

const ActionButton = (props) => {
  return (
    <Button textColor={actionText} bg={actionBg} {...props}>{props.children}</Button>
  );
}

export default ActionButton;


/** WEBPACK FOOTER **
 ** ./src/components/ActionButton.js
 **/